export default class DocumentMacro {
    constructor(elm) {
        // Making the macro's background color a light shade of blue,
        // if the background behind the macro is white.
        let isInSectionGroup = false;
        let bodyBackgroundIsWhite = false;
        let hasColoredSectionGroupBackground = false;
        const fifthAncestor = elm.parentNode.parentNode.parentNode.parentNode.parentNode;

        if (document.querySelector('body').classList.contains('page-color-white')) {
            bodyBackgroundIsWhite = true;
        }

        if (fifthAncestor.classList.contains('section-group')) {
            isInSectionGroup = true;
        }

        if (isInSectionGroup && !fifthAncestor.classList.contains('theme-white')) {
            hasColoredSectionGroupBackground = true;
        }

        if (bodyBackgroundIsWhite && (hasColoredSectionGroupBackground === false)) {
            elm.style.backgroundColor = '#f7fafd';
        }
    }
}
